export function isNotNullOrUndefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isNullOrUndefined<T>(value: T | null | undefined): value is null | undefined {
  return value === null || value === undefined;
}

export function isTruthy<T>(value: T): value is NonNullable<T> & Exclude<T, false | '' | 0> {
  return Boolean(value);
}
